import { apolloClient } from "@/plugins/apollo/apollo";

export const handleGqlResponseBody = async (successCb) => {
  const response = await successCb(apolloClient);
  return response.data[Object.keys(response.data)[0]];
};
